/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { connect } from 'react-redux';

import groupSelectors from '../../../redux/reduxStore/group';
import GroupMetadata from '../../../models/GroupMetadata';

import GroupLogoTemplate from './GroupLogo.template';

import './GroupLogo.css';

function mapStateToProps(state) {
  return {
    groupMetadata: groupSelectors.getActiveGroup(state),
  };
}


const GroupLogoWithDefault = (props) => {
  const group = new GroupMetadata(props.groupMetadata);
  const baseColor = group.theme.getBaseCssColor();

  return (
    <GroupLogoTemplate
      {...props}
      hasDots={false}
      BackupLogo={() => (
        <div className="cmp-grouplogo-default" style={{ height: props.size, width: props.size, backgroundColor: baseColor, flexShrink: 0 }}>
          {group.groupName.getInitials()}
        </div>
      )}
    />
  );
}

export default connect(mapStateToProps)(GroupLogoWithDefault);
